/** The Profile piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { ProfileEvents } from './contract';
import { ProfileView } from './ProfileView';
import { useProfile } from './useProfile';

export { ProfileView, useProfile };

export function Profile(props: PieceInput<ProfileEvents>) {
  return <ProfileView {...useProfile(props)} />;
}
